
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setting",
      function () {
        return require("private-next-pages/setting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/setting"])
      });
    }
  